import {useRef} from 'react';
import {Pie, NumberLabels} from '../libs';
import {CHART_COLORS} from '../theme';

export function dataFromEstate({dividuals}: Estate): Parameters<typeof Pie>[0]['data'] {
  return {
    labels: dividuals.map(({name}) => name),
    datasets: [{
      data: dividuals.map(({ratio}) => ratio),
      backgroundColor: CHART_COLORS.map(({bg}) => bg ?? 'gray'),
      borderColor: 'black'
    }]
  };
}

type Props = {
  estate: Estate
};

export default function RatiosChart({estate}: Props) {
  const ref = useRef(null);

  return (
    <Pie ref={ref} data={dataFromEstate(estate)} plugins={[NumberLabels]} />
  );
}
